import Api from './api';

export const getById = async (id) => { 
  let data = []
  await Api.get(`/calledservicesettingscalledfield/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByIdWithoutIncludes = async (id) => { 
  let data = []
  await Api.get(`/calledservicesettingscalledfield/${id}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getAllByCalledServiceSettingsId = async (calledServiceSettingsId) => { 
  let data = []
  await Api.get(`/calledservicesettingscalledfield/all/calledservicesettings/${calledServiceSettingsId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getAllByCalledServiceSettingsIdWithoutIncludes = async (calledServiceSettingsId) => { 
  let data = []
  await Api.get(`/calledservicesettingscalledfield/all/calledservicesettings/${calledServiceSettingsId}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const paginate = async (page, search, field, size = 10) => { 
  let data = []

  let url = `/calledservicesettingscalledfield/paginate?page=${page}&size=${size}`
  if (search != '' && field != 0)
    url += `&search=${search}&field=${field}`

  await Api.get(url)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const addItem = async (formData) => { 
  let data = []
  await Api.post(`/calledservicesettingscalledfield`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const editItem = async (formData) => { 
  let data = []
  await Api.put(`/calledservicesettingscalledfield`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteItem = async (id) => { 
  let data = []
  await Api.delete(`/calledservicesettingscalledfield/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteItems = async (idList) => { 
  let data = []
  await Api.delete(`/calledservicesettingscalledfield/items/${idList}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}